// An order number in a support message ("#329891CD - тази поръчка не дойде")
// becomes a chip that shows the order on hover: its state, when it was
// placed, what is in it and where it goes — what the orders screen shows —
// with a way to the order itself. Registered with the customer-support chat
// at boot (routes.js imports this file).
import React from "react"
import { registerReference } from "aldoo-ra/Admin/CustomerSupport/references"
import { GetOrder } from "../AdminShared/api"
import { Chip, Thumb, money, dateTime, orderState } from "../AdminShared/ui"
import { placedAt } from "aldoo-ra/StoreOrders/ui"

// an order number is the last 8 hex digits of its transaction, upper case,
// with or without the # people write before it; a word of letters alone
// ("DECEADED") is not one
const PATTERN = /#?\b(?=[0-9A-F]*\d)[0-9A-F]{8}\b/g

const address = (a) => (a ? [a.name, a.street || a.line1, a.line2, [a.postalCode || a.postal_code, a.city].filter(Boolean).join(" "), a.country].filter(Boolean).join(", ") : "")

function OrderCard({ data: order, token }) {
  const id = order.orderId || token
  // an order always says what it was paid in
  const currency = order.currency
  const items = order.cart || order.items || []
  const state = orderState(order)
  const total = order.total ?? order.amount ?? items.reduce((sum, i) => sum + (i.price ?? 0) * (i.quantity ?? 1), 0)
  const where = address(order.shippingAddress || order.address || order.billingAddress)
  return (
    <div className="p-3 text-sm" data-testid="order-card">
      <div className="flex items-center justify-between gap-3">
        <span className="font-semibold">Order #{id}</span>
        <Chip className={state.className}>{state.label}</Chip>
      </div>
      <div className="mt-0.5 text-xs text-admin_text_secondary">
        {dateTime(placedAt(order))}
        {order.email ? ` · ${order.email}` : ""}
      </div>
      <ul className="m-0 mt-3 list-none p-0 flex flex-col gap-2 max-h-[220px] overflow-y-auto">
        {items.map((item, i) => (
          <li key={`${item.pid}-${i}`} className="flex items-center gap-2">
            <Thumb src={item.thumbnail} name={item.name || item.pid} className="w-9 h-9 rounded shrink-0" />
            <span className="min-w-0 flex-1 truncate">{item.name || item.pid}</span>
            <span className="shrink-0 tabular-nums text-admin_text_secondary">{item.quantity ?? 1} × {money(item.price, currency)}</span>
          </li>
        ))}
        {items.length === 0 && <li className="text-admin_text_secondary">—</li>}
      </ul>
      <div className="mt-3 flex items-center justify-between border-t border-admin_bordered pt-2">
        <span className="text-admin_text_secondary">Total</span>
        <span className="font-semibold tabular-nums">{money(total, currency)}</span>
      </div>
      {where && <div className="mt-2 text-xs text-admin_text_secondary whitespace-pre-line">{where}</div>}
      <a href={`/admin/store/orders?order=${encodeURIComponent(order._id || id)}`} className="mt-3 inline-block text-xs font-semibold text-admin_primary hover:underline">Open the order</a>
    </div>
  )
}

registerReference({
  id: "order",
  pattern: PATTERN,
  resolve: async (token) => {
    const res = await GetOrder(token).catch(() => null)
    return res?.order || null
  },
  Card: OrderCard,
})
